/* eslint-disable @typescript-eslint/no-explicit-any */

import { ls } from '@sfe/bone-cache';
import {PLATFORM_SUPPORT_LANGUAGES} from '@bfe/by-shared-settings';
import { isBrowser } from '../browser';
import { CustomAxiosRequestConfig, WebReq } from './index';
// todo
// i18n.global.locale.value.toLowerCase()
const i18n: any = {
  global: {
    t: (key: string) => key,
  },
};

export const getBrowserLanguage = () =>
  navigator.language ||
  (navigator as any).browserLanguage ||
  (navigator as any).userLanguage;

export const LOCALE_LS_KEY = 'BYBIT_LANG_KEY';

export const getCookieLanguage = () => {
  const value = ls.get(LOCALE_LS_KEY);
  return value;
};

const isSupport = (lang: string) => {
  const locales = PLATFORM_SUPPORT_LANGUAGES.map((locale) => locale.value);
  return locales.includes(lang)
}

export const getDefaultLang = () => {
  if (isBrowser) {
    const pathname = window.location.pathname;
    const pathArr = pathname.split('/');
    const urlLang = pathArr[1];
    const browserLang = getBrowserLanguage();
    const cookieLang = getCookieLanguage();
    const lang = isSupport(urlLang) ? urlLang : cookieLang || browserLang;
    return lang;
  }
  return 'en';
};

export const getHeaders = (config: CustomAxiosRequestConfig) => {
  const lang = getDefaultLang();
  return {
    'Content-Type': config.contentType || 'application/json',
    lang,
    'Accept-Language': lang,
  };
};

export const error = (err: any) => {
  let code = 500;
  let errMsg =
    i18n?.global?.t('network_error') ||
    'Request failed. Please try again later.';

  try {
    if (err.response) {
      const res = err.response;
      const data = res.data || {};

      code = data.ext_code || res?.request?.status || res?.status || code;
      errMsg = data.ret_msg || data.error || errMsg;
    }
  } catch (e) {
    //
  }

  return {
    success: false,
    code,
    message: errMsg,
    data: null,
  };
};
// 兼容接口返回的小驼峰 返回值，以及其msg 不支持中文，会用urlEncode编码，这里需要解码
function adaptResponse(data: any) {
  if (!data) {
    return;
  }
  if (data.ret_code === undefined) {
    data.ret_code = data.retCode;
  }
  if (data.ret_msg === undefined) {
    try {
      data.ret_msg = decodeURIComponent(data.retMsg);
    } catch {
      data.ret_msg = data.retMsg;
    }
  }
}

/**
 * 格式化响应数据
 *
 * @param {Object} res axios Response Schema: https://github.com/axios/axios#response-schema
 * @return {Object} 返回响应数据结果对象
 */
export const transformResponse = (res: any) => {
  let data = res.request && res.config ? res.data : res;
  adaptResponse(data);
  // 响应拦截器
  if (res.config && typeof res.config.interceptRes === 'function') {
    data = res.config.interceptRes(data, res);
  }

  // 如果不是正常 JSON 数据则认为是错误
  if (typeof data !== 'object') {
    return error('数据响应格式不正确。');
  }
  // 封装后端 Response Schema
  // 具体需要根据后端而定
  data.success = data.ret_code === 0;
  data.code = data.ret_code;
  data.message =
    !data.ret_msg && data.ret_code !== 0
      ? 'Access error, please try again later'
      : data.ret_msg;
  data.result = Object.prototype.hasOwnProperty.call(data, 'result')
    ? data.result
    : null;
  return data;
};
/**
 * 解析路由参数responseType
 *
 */
const reg = /:[a-z|A-Z]+/g;
export function parseParams(url: string): Array<string> {
  const ps = url.match(reg);
  if (!ps) {
    return [];
  }
  return ps.map((k) => k.replace(/:/, ''));
}

/**
 * 按照url和params生成相应的url
 * @param url
 * @param params
 */
export function genUrl(url: string, params: WebReq['params']) {
  if (!params) {
    return url;
  }

  const ps = parseParams(url);
  ps.forEach((k) => {
    const reg = new RegExp(`:${k}`);
    url = url.replace(reg, params[k]);
  });

  const path: Array<string> = [];
  for (const key of Object.keys(params)) {
    if (!ps.find((k) => k === key)) {
      path.push(`${key}=${params[key]}`);
    }
  }

  return url + (path.length > 0 ? `?${path.join('&')}` : '');
}
